import {Form, Input, notification, Skeleton} from "antd";
import SelectPricingSnapshot from "../SelectPricingSnapshot";
import BMReadOnly from "../BMReadOnly";
import PricingView from "./PricingView";
import React, {useContext} from "react";
import {useQuoteContext} from "../../contexts/QuoteContext";
import {useIntl} from "react-intl";
import {ConfiguratorContext} from "../../context";
import useQuote from "../../swr/useQuote";
import {SaveDto} from "../../api";

const PricingViewPanel = (props: {
    onQuoteChanged: (q:SaveDto | undefined) => void
}) => {

    const configurator = useContext(ConfiguratorContext);
    const intl = useIntl();

    const isAdmin = configurator.isAdmin();
    const isDealer = configurator.isDealerSales();
    const isFinance = configurator.isFinance();
    const {quote } = useQuoteContext();

    const quoteAsync = useQuote({ quoteId: quote?.quoteId, revision: quote?.revision });

    const updatePricingSnapshot = async (pricingSnapshotId?: number | undefined) => {
        if ( !quote ) return;

        try {

            const resp = await configurator.api.updatePricingSnapshot( quote.displayRevisionId, pricingSnapshotId );
            if ( resp ) {

                notification.success({message: "Successfully update price, please submit quote approval."});

                await quoteAsync.mutate(resp.data);
            }

        } catch (e:any) {
            const errorMsg = intl.formatMessage({ id: e.message });
            notification.error( { message: "Failed to update pricing. " + errorMsg });
        }

    }


    return <Skeleton loading={!quote} active >
        <Form.Item
            label={<strong>Pricing Configuration</strong>}
        >
            {!isDealer
                ? <SelectPricingSnapshot
                    value={quote?.pricingConfig?.pricingSnapshot?.id}
                    onChange={(pricingSnapshotId) => updatePricingSnapshot(pricingSnapshotId)}
                    disabled={!(isAdmin || isFinance)}
                />
                : <BMReadOnly value={quote?.pricingConfig.pricingSnapshot?.name}  readOnly={true}><Input /></BMReadOnly>}
        </Form.Item>

        <PricingView onChange={props.onQuoteChanged} />
    </Skeleton>
}

export default PricingViewPanel;
